module.exports = __webpack_public_path__ + "static/media/8.21f12a99.png";